import { z } from "zod/v4";

export const serviceTaskStatusValues = ["open", "done"] as const;

export const serviceTaskStatusSchema = z.enum(serviceTaskStatusValues);
export type ServiceTaskStatus = z.infer<typeof serviceTaskStatusSchema>;

export const serviceTaskTypeValues = [
  "masterDataEntry",
  "masterDataEntryTaxAdvisory",
  "powerOfAttorneyUpload",
  "closeTheBooks",
  "checkSpecialCase",
  "checkTaxAdvisorReview",
  "updateOffer",
  "handOverToTaxAdvisor",
  "sendAnnualStatementToClient",
  "prepareDisclosure",
  "checkDisclosure",
  "clarifyWithTaxOfficeBlocking",
  "clarifyWithTaxOfficeNonBlocking",
  "prepareClientDelivery",
  "bookInDatev",
  "handOverToTechTax",
] as const;

export const serviceTaskTypeSchema = z.enum(serviceTaskTypeValues);
export type ServiceTaskType = z.infer<typeof serviceTaskTypeSchema>;

export const serviceTaskSchema = z.object({
  id: z.string().uuid(),
  companyId: z.string(),
  year: z.number().int(),
  type: serviceTaskTypeSchema,
  status: serviceTaskStatusSchema.default("open"),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ServiceTask = z.infer<typeof serviceTaskSchema>;
